import { useCallback } from 'react';

import { usePermissionsContext } from '@gasbi/shared';

import type { UserPermissionType } from '@/features/permissions';

/** `can(a, b)` is true when the user has at least one of the listed permissions, like the backend's [Permission(a, b)]. */
const useCan = () => {
  const { hasPermission } = usePermissionsContext();

  return useCallback(
    (...permissions: UserPermissionType[]) =>
      permissions.some(permission => hasPermission(permission)),
    [hasPermission],
  );
};

export default useCan;
